import { ThirtyDayIcon } from "@/components/icons/free-monitoring/30day.icon";
import { ActivateIcon } from "@/components/icons/free-monitoring/activate.icon";
import { AfterThirtyDayIcon } from "@/components/icons/free-monitoring/after30day.icon";
import { Text } from "@/components/text/text.component";

export function HowItWorksPanel() {
  const renderSteps = () =>
    steps.map(({ title, description, Icon }, index) => (
      <div
        key={title}
        className="relative flex flex-1 flex-col items-center gap-3 text-center">
        {index < steps.length - 1 ? (
          <span
            aria-hidden
            className={`absolute top-10 right-[calc(-50%+40px)] left-[calc(50%+40px)] hidden h-1 bg-gradient-to-r min-[720px]:block ${
              index === 0
                ? "from-[#9DE5FF] to-[#5DCDFF]"
                : "from-[#5DCDFF] to-[#00226A]"
            }`}
          />
        ) : null}
        <Icon
          aria-hidden
          width={80}
          height={80}
          className="bg-greyscale-background relative z-10"
        />
        <div className="flex flex-col gap-1">
          <Text
            component="h4"
            variant="subtitle1"
            className="text-greyscale-headline">
            {title}
          </Text>
          <Text component="p" variant="body4">
            {description}
          </Text>
        </div>
      </div>
    ));

  return (
    <section className="flex flex-col gap-5">
      <Text component="h3" variant="h5" className="text-greyscale-headline">
        How it works
      </Text>
      <div className="bg-greyscale-background flex flex-col gap-8 rounded-2xl px-5 py-7 min-[720px]:flex-row min-[720px]:items-start min-[720px]:gap-5 min-[720px]:px-8 min-[720px]:py-10">
        {renderSteps()}
      </div>
    </section>
  );
}

const steps = [
  {
    title: "Activate your system",
    description:
      "Activate your devices in your ADT+ app within 30 days of shipping to start your free month.",
    Icon: ActivateIcon,
  },
  {
    title: "Before 30-day period ends",
    description: "We'll send you a reminder before your 30-day period ends.",
    Icon: ThirtyDayIcon,
  },
  {
    title: "After 30 days",
    description:
      "If you don't cancel at least 24 hours before your 30-day free period ends, your monthly service charges begin.",
    Icon: AfterThirtyDayIcon,
  },
];
